export const adTypes = {
  IMAGE: 'image',
  LANDING: 'landing',
  SELFCODE: 'selfcode',
  HTML5: 'html5',
  VIDEO: 'video',
  MOTION_BANNER: 'motion_banner',
  WRAPPER_WITH_VIDEO: 'wrapper_with_video',
  WRAPPER_WITH_VPAID: 'wrapper_with_vpaid',
  REWARDED_POST: 'rewarded_post'
}
